import React, { useEffect, useState } from "react"
import NavMain from "./nav-main"
import { StaticImage } from "gatsby-plugin-image"
import { useCookies } from "react-cookie"

export default function MagazineMainNav() {
  const [cookies] = useCookies([]);
  const [isLoggedIn, setIsLoggedIn] = useState(null)

  useEffect(() => {
    setIsLoggedIn(!!cookies['member_id'])
  }, [])

  function Search(e) {
    e.preventDefault()
    document.querySelector('#header-search-form').submit()
  }

  return (
    <header id="unity-header" className="header-position">
      <div className="unity-header-inner">
        <nav>
          <h1>
            <a href="https://laxus.co/app/pc/home">
              <StaticImage className="footer-logo-img" alt="Laxus" src="../images/logo-black.png" />
            </a>
          </h1>
          <ul id="main-nav">
            <li><a href="https://laxus.co/app/pc/info/brandlist">取扱ブランド一覧</a></li>
            <li><a href="https://laxus.co/app/pc/bags">特集</a></li>
            <li><a href="https://laxus.co/app/pc/blog/outfit">Outfit</a></li>
            <li><a href="https://laxus.co/app/pc/blog/news">NEWS</a></li>
            <li><a href="https://laxus.co/magazine">ブログ</a></li>
            <li><a href="https://laxus.co/app/pc/search">詳細検索</a></li>
            {(isLoggedIn === null || !isLoggedIn) && <li className="regi"><a href="https://laxus.co/app/pc/login/register">会員登録</a></li>}
            {(isLoggedIn === null || isLoggedIn) && <li className="fav"><a href="https://laxus.co/app/pc/mypage/show_like_list">お気に入り</a></li>}
            {(isLoggedIn === null || isLoggedIn) && <li className="mypage"><a href="https://laxus.co/app/pc/mypage">マイページ</a></li>}
            <li><a href="https://laxus.co/app/pc/info/howto">ヘルプ</a></li>
            {/* <li className="header-youtube-pc">
              <a href="https://laxus.co/app/pc/youtube" target="_blank" rel="noreferrer">
                <StaticImage alt="Youtube" src="../images/snsyt.svg" />
              </a>
            </li> */}
          </ul>
        </nav>
        <div className="search-form">
          <form id="header-search-form" method="post" action="https://laxus.co/app/pc/search/result">
            <input id="con_keyword" name="con_keyword" className="conkw" placeholder="バッグを探す" />
            <input id="con_keyword_sp" name="con_keyword_sp" className="conkw" placeholder="バッグを探す" />
            <a href="https://laxus.co/app/pc/search/result" onClick={Search}>
              <div className="search-btn">
                <StaticImage className="Search-btn-img" alt="Search" src="../images/search.png" />
              </div>
            </a>
            <input type="submit" value="soushin" style={{display: "none"}} />
          </form>
        </div>
        <div className="sp_bars sp_bars_change">
          <a href="#barsmenu" data-micromodal-trigger="modal-1">
            <StaticImage className="bars-black" alt="メニュー" src="../images/menu-bars-black.png" />
          </a>
        </div>
      </div>
      <NavMain />
    </header>
  )
}